import { render } from "./ModelSidebar.vue?vue&type=template&id=201ca23e&ts=true"
import script from "./ModelSidebar.vue?vue&type=script&lang=ts&setup=true"
export * from "./ModelSidebar.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Components/ModelSidebar.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "201ca23e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('201ca23e', __exports__)) {
    console.log('reload')
    api.reload('201ca23e', __exports__)
  }
  
  module.hot.accept("./ModelSidebar.vue?vue&type=template&id=201ca23e&ts=true", () => {
    console.log('re-render')
    api.rerender('201ca23e', render)
  })

}


export default __exports__